import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function FDWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1166">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1167">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1168">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-1169">
            <div className="relative w-full aspect-square overflow-hidden shadow-xl" data-id="element-1170">
              <img src="https://cdn.magicpatterns.com/uploads/xejZa6H924ZFxJueouX3Fh/Rectangle-2511.jpg" alt="Be CLINICAL Team" className="w-full h-full object-cover" data-id="element-1171" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-1172">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1173">
              WHY CHOOSE BE CLINICAL FOR INJECTABLES
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-1174"></div>

            <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-1175">
              <p data-id="element-1176">
                Be CLINICAL is a standout choice for fat-dissolving injections
                due to our commitment to effectiveness and innovation,
                highlighted by our proprietary solution, BeSCULPTED. This
                signature treatment is designed to permanently destroy fat cells
                in targeted areas, showcasing our dedication to providing
                advanced, results-driven care.
              </p>
              <p data-id="element-1177">
                Led by Dr. Fiona Frie, a dual-certified internist and
                anesthesiologist, our team ensures treatments are administered
                with precision and safety. Be CLINICAL's patient-centered
                approach means every treatment plan is tailored to individual
                goals, with clear communication about outcomes and benefits.
                We're a trusted destination for achieving aesthetic and wellness
                transformations. Begin your journey with us today by scheduling
                your consultation!
              </p>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1178">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}